/* eslint-disable no-undef, no-unused-vars */
// import 'bootstrap';

import * as bootstrap from 'bootstrap';

  $(() => {

    if (!$('body').hasClass('page-template-template-directory')) {
      return;
    }

    // JavaScript to be fired on the directory page
    const $clearButton = $('#clearButton');
    const $members = $('.ppn-member');
    let timeout;

    let initDetailTimeout;
    let returnTo;
    let filteredMembersArray = [];

    // Get variable from wp_localize_script
    let membersArray = JSON.parse(members_json);
    if (!Array.isArray(membersArray)) {
      membersArray = Object.values(membersArray);
    }

    const $memberTemplate = $('#directoryMembers .ppn-member').clone().removeClass('d-none');

    const directoryModalElement = document.getElementById('directoryModal');

    const $directoryModal = new bootstrap.Modal(directoryModalElement, {});

    // console.log('members', membersArray);

    let currentPage = 1;
    const recordsPerPage = 24;
    const pageNumStr = '<a class="page-numbers change-page" href="#" data-page="pageNum">pageNum</a>';
    const curNumStr = '<span aria-current="page" class="page-numbers current">pageNum</span>';
    const dotStr = '<span class="page-numbers dots">…</span>';

    function removeHash() {
      const noHashURL = window.location.href.replace(/#.*$/, '');
      window.history.replaceState('', document.title, noHashURL);
    }

    function removeAreaSegment() {
      const noAreahURL = window.location.href.replace(/area.*$/, '');
      window.history.replaceState('', document.title, noAreahURL);
    }

    function selectMember(id) {
      clearTimeout(initDetailTimeout);
      // if (!mapLoaded){
      //   initDetailTimeout = setTimeout(function () {
      //     selectMember(id);
      //   }, 101);
      //   return;
      // }

      const member = membersArray.find(el => el['Registration Number'] === id);
      if (!member) return;

      // console.log('member', id, member);

      $('#orgName').html(member['Organisation Name']);

      displayField($('#orgPillar'), member['Group Pillar']);
      displayField($('#orgCause'), member['What is the main cause of your group']);
      displayField($('#orgArea'), member['Geographical area your group covers']);
      displayField($('#orgWebsite'), member['Website']);
      displayField($('#orgFacebook'), member['Facebook page']);
      displayField($('#orgInstagram'), member['Instagram Page']);
      displayField($('#orgLinkedIn'), member['LinkedIn']);
      displayField($('#orgTwitter'), member['Twitter page']);
      displayField($('#orgRegistrationumber'), member['Registration Number']);
      displayField($('#orgStructure'), member["Group's structure"]);
      displayField($('#orgEstablished'), member['Date Established']);
      displayField($('#orgDescription'), member['Description/Aims']);

      $('#memberDetail').removeClass('community')
      .removeClass('environment')
      .removeClass('social')
      .addClass(member['class'] );

      // if ($('#map').hasClass('show')) {
      //   returnTo = 'map';
      // } else {
      //   returnTo = 'members';
      // }

      $directoryModal.show();
    }

    function displayField($ele, value) {
      const $fieldText = $ele.find('.field-text');
      if (value) {
        if (value.indexOf('URL: ') > -1) {
          value = value.split('URL: ')[1];
          value = '<a href="' + value + '" target="_blank" rel="nofollow">' + value + '</a>';
        }
        $ele.removeClass('d-none');
        if ($ele.hasClass('type-flex')) {
          $ele.addClass('d-flex');
        }
        $fieldText.html(value);
      } else {
        $ele.addClass('d-none');
        if ($ele.hasClass('type-flex')) {
          $ele.removeClass('d-flex')
        }
        $fieldText.html('');
      }
    }

    function hideMember($ele) {
      $ele.removeClass('d-flex').addClass('d-none');
    }

    function showMember($ele) {
      $ele.removeClass('d-none').addClass('d-flex');
    }

    function addMember(member) {
      const $ele = $memberTemplate.clone();
      const id = member['Registration Number'];

      $ele.attr('id', id);

      $ele.find('a').attr( 'href', '#' + id )
      .on('click', function() {
        selectMember(id);
      });

      $ele.find('.card-body').addClass(member['class']);

      $ele.find('.entry-title a').html(member['Organisation Name']);

      $ele.find('.member-pillar .field-text').html(member['Group Pillar']);

      $ele.find('.member-cause .field-text').html(member['What is the main cause of your group']);

      $ele.find('.member-area .field-text').html(member['Geographical area your group covers']);

      $( '#directoryMembers' ).append($ele);
    }

     function filterMembers(){
        filteredMembersArray = [];
        currentPage = 1;
        let i = 0;
        const name = $('#nameInput').val().toLowerCase();

        const filtersObj = {
            'Group Pillar': $('#pillarSelect').val(),
            'What is the main cause of your group': $('#causeSelect').val(),
            'Geographical area your group covers': $('#areaSelect').val(),
        };

      //Get array of filtered members
      $.each( membersArray, function( index, member ) {
      // membersArray.forEach(member => {
        // console.log('member', member);
        let isPresent = true;

        const orgName = member['Organisation Name'];
        if (!orgName) {
          isPresent = false;
        } else if (name && orgName.toLowerCase().indexOf(name) === -1){
            isPresent = false;
        }

        $.each( filtersObj, function( key, value ) {
            if (value && member[key] !==  value){
                    isPresent = false;
            }
        });

        if (isPresent) {
            filteredMembersArray.push(member);
        }
      });

      $('#resultsBadge').text(filteredMembersArray.length);

      //Display first page of filtered objects
      changePage(1);

      // if ($('#map').hasClass('show')) {
      //   // if (!mapLoaded) {
      //   //   debouncefilterMembers(500);
      //   //   return;
      //   // }
      //   //Set directory map markers
      //   $('.directory-map').each(function(){
      //     let map = $(this).data('map');
      //     if (!map) {
      //       return;
      //     } else {
      //       setMarkers(map);
      //     }
      //   });
      // }
    }

    function debouncefilterMembers(delay){
        if (delay === undefined) {
                delay = 0;
        }
        clearTimeout(timeout);

        timeout = setTimeout(function () {
            filterMembers();
        }, delay);
    }

    $('.posts-filter input').on('change keyup paste', function(){
        //console.log('change');
        debouncefilterMembers(1000);
    });

    $('.posts-filter select').on('change', function(){
        //console.log('change');
        debouncefilterMembers(100);
    });

    $('#clearNameButton').on('click', function(){
        //console.log('clear');
        $('#nameInput').val('');
        debouncefilterMembers(0);
    });

    $clearButton.on('click', function(){
        $('.posts-filter .form-control').val('');
        removeAreaSegment();
        debouncefilterMembers(0);
    });

    directoryModalElement.addEventListener('hide.bs.modal', function () {
      // remove hash
      removeHash();
    })

    const hash = window.location.hash;
    if (hash) {
        //show member
        const id = hash.substring(1);
        selectMember(id);
    }

    function scrollMembers() {
      $('.posts-grid').get(0).scrollIntoView({behavior: 'smooth'});
    }

    //Pagination

    // Implementation in ES6
    function getRangeWithDots(current, last) {
        let delta = 2,
        left = current - delta,
        right = current + delta + 1,
        range = [],
        rangeWithDots = [],
        l;

    for (let i = 1; i <= last; i++) {
        if (i == 1 || i == last || i >= left && i < right) {
            range.push(i);
        }
    }

    $.each( range, function( index, i ) {
        if (l) {
            if (i - l === 2) {
                rangeWithDots.push(l + 1);
            } else if (i - l !== 1) {
                rangeWithDots.push('...');
            }
        }
        rangeWithDots.push(i);
        l = i;
    });

    // console.log('range', rangeWithDots);
    return rangeWithDots;
}

    function pagination() {
      $('a.change-page').off('click');

      if (getNumPages() <= 1) {
        $('.pagination').hide();
        return;
      } else {
        $('.pagination').show();
      }

      const rangeWithDots = getRangeWithDots(currentPage, getNumPages());
      let rangeStr = '';

      $.each( rangeWithDots, function( key, value ) {
        if (value === '...') {
          rangeStr += dotStr;
        } else if (value == currentPage) {
          rangeStr += curNumStr.replace(/pageNum/g, value);
        } else {
          rangeStr += pageNumStr.replace(/pageNum/g, value);
        }
      });

      $('.pageNums').html(rangeStr);
      $('a.change-page').on('click', function(e) {
        const pageNum = $(this).data('page');
        if (pageNum) {
          changePage(pageNum);
          scrollMembers();
        }
        e.preventDefault();
        return false;
      });
    }

    function getNumPages() {
      return Math.ceil(filteredMembersArray.length / recordsPerPage);
    }

    function changePage(pageNum) {
      currentPage =  Math.min(Math.max(pageNum, 1), getNumPages());
      // console.log('changePage', currentPage);

      // hideMember($members);

      $( '#directoryMembers' ).empty();

      filteredMembersArray.forEach((member, i) => {
        if (i >= (currentPage-1) * recordsPerPage && i < currentPage * recordsPerPage) {
          // const $ele = $('div#'+ member['Registration Number']);
          // showMember($ele);

          addMember(member);
        }
      });
      // newPageNumbers();
      pagination(currentPage, getNumPages());
    }

    function prevPage(e) {
        if (currentPage > 1) {
            currentPage--;
            changePage(currentPage);
            scrollMembers();
        }

        if (e) {
          e.preventDefault();
        }
        return false;
    }

    function nextPage(e) {
        if (currentPage < getNumPages()) {
            currentPage++;
            changePage(currentPage);
            scrollMembers();
        }
        if (e) {
          e.preventDefault();
        }
        return false;
    }

    function preselectArea() {
      if (!apiObj) {
        removeAreaSegment();
        return;
      }

      const area = apiObj.area;
      if (area) {
        const title = area.replace(/-/g, ' ').replace(/\b[a-z]/g, function() {
          return arguments[0].toUpperCase();
        });
        const $areaSelect = $('#areaSelect');
        $areaSelect.val(title);
        if (!$areaSelect.val()) {
          $areaSelect.val('');
          removeAreaSegment();
        }

        $areaSelect.on('change', function(){
          removeAreaSegment();
        });

      } else {
        removeAreaSegment();
        return;
      }

    }

    $('.prev').on('click', prevPage);
    $('.next').on('click', nextPage);

    preselectArea();
    filterMembers();
  });

